import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { LAZY_VIEW_ENTRY_COMPONENT } from '../lazy-view/lazy-view-entry-component.injection-token';
import { SharedComponentsModule } from '../shared/directives/shared-components.module';
import { IconFontModule } from '../shared/icon-font/icon-font.module';
import { InstrumentationModule } from '../shared/instrumentation/instrumentation.module';
import { ResizeModule } from '../shared/resize/resize.module';
import { FeedbackComponent } from './feedback.component';

@NgModule({
    imports: [
        CommonModule,
        SharedComponentsModule,
        IconFontModule,
        InstrumentationModule,
        ResizeModule
    ],
    declarations: [
        FeedbackComponent
    ],
    exports: [
        FeedbackComponent
    ],
    providers: [
        { provide: LAZY_VIEW_ENTRY_COMPONENT, useValue: FeedbackComponent }
    ],
    entryComponents: [
        FeedbackComponent
    ]
})
export class FeedbackModule {
}
